import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../Components/api/axiosInstance";

export const sesurfaceData = createAsyncThunk(
  "sesurface",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/weather/seasurface-forecast",
        data,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  },
);

const seasurfaceSlice = createSlice({
  name: "sesurface",
  initialState: {
    sesurface: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sesurfaceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sesurfaceData.fulfilled, (state, action) => {
        state.loading = false;
        state.sesurface = action.payload;
      })
      .addCase(sesurfaceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default seasurfaceSlice.reducer;
